import { createSignal } from "solid-js";
import type { AppPhase, InferenceMetrics } from "./types.ts";

// ── Global reactive state ───────────────────────────────────────────────────

/** Current application phase. */
export const [phase, setPhase] = createSignal<AppPhase>("startup");

/** Real-time audio level (0..1) from AnalyserNode, drives visuals. */
export const [audioLevel, setAudioLevel] = createSignal(0);

/** Latest inference result text (displayed as caption). */
export const [currentText, setCurrentText] = createSignal("");

/** Metrics from the latest inference. */
export const [metrics, setMetrics] = createSignal<InferenceMetrics | null>(null);

/** Cumulative chunk counter. */
export const [chunkCount, setChunkCount] = createSignal(0);

/** Active prompt (editable at runtime). */
export const [prompt, setPrompt] = createSignal(
  "Write a brief caption about this audio within 15 words."
);

/** Microphone device label. */
export const [deviceLabel, setDeviceLabel] = createSignal("—");

/** Model loading progress (0..1), -1 when not loading. */
export const [loadProgress, setLoadProgress] = createSignal(-1);

/** Error message (empty when no error). */
export const [errorMsg, setErrorMsg] = createSignal("");

/** Download progress (0..1), -1 when not downloading. */
export const [downloadProgress, setDownloadProgress] = createSignal(-1);

/** Download phase label (e.g. "Downloading backbone…"). */
export const [downloadLabel, setDownloadLabel] = createSignal("");

/** Whether models were loaded from OPFS cache. */
export const [modelsFromCache, setModelsFromCache] = createSignal(false);

/** Chunk buffer progress (0..1) — how full the current 5s audio chunk is. */
export const [chunkProgress, setChunkProgress] = createSignal(0);

/** Model info once loaded. */
export const [modelSampleRate, setModelSampleRate] = createSignal(16_000);

